import React, { Component } from 'react';

class Details extends Component {
    render() {
        return <h1>Event Details landing page</h1>;
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/components/details/index.js